// Messages for operator/settings/SystemAudit (auto-merged into the i18n catalog).
export const en = {
  'operator.system_audit.head': 'System audit — Operator',
  'operator.system_audit.title': 'System audit',
  'operator.system_audit.desc':
    'The raw audit trail with full before/after values, including system-actor events.',
  'operator.system_audit.filter.all': 'All events',
  'operator.system_audit.filter.system': 'System actors',
  'operator.system_audit.system': 'System',
  'operator.system_audit.col.when': 'When',
  'operator.system_audit.col.action': 'Action',
  'operator.system_audit.col.record': 'Record',
  'operator.system_audit.col.actor': 'Actor',
  'operator.system_audit.col.changes': 'Changes',
  'operator.system_audit.empty': 'No audit events match.',
  'operator.system_audit.prev': 'Prev',
  'operator.system_audit.next': 'Next',
  'operator.system_audit.page': 'Page {page} of {pages}',
}

export const zhTW = {
  'operator.system_audit.head': '系統稽核 — 操作員',
  'operator.system_audit.title': '系統稽核',
  'operator.system_audit.desc': '包含完整前後值的原始稽核軌跡，包括系統執行者事件。',
  'operator.system_audit.filter.all': '所有事件',
  'operator.system_audit.filter.system': '系統執行者',
  'operator.system_audit.system': '系統',
  'operator.system_audit.col.when': '時間',
  'operator.system_audit.col.action': '動作',
  'operator.system_audit.col.record': '記錄',
  'operator.system_audit.col.actor': '執行者',
  'operator.system_audit.col.changes': '變更',
  'operator.system_audit.empty': '沒有符合的稽核事件。',
  'operator.system_audit.prev': '上一頁',
  'operator.system_audit.next': '下一頁',
  'operator.system_audit.page': '第 {page} 頁，共 {pages} 頁',
}
